import { LitElement, html } from 'lit';
import styles from './styles';
import '../../../shared/components/icons/IconCheck';

class PartnersRegistrationConfirmation extends LitElement {
  static styles = styles;

  render() {
    return html`
      <div class="confirmation-box" id="partners-registration-form-confirmation">
        <tenable-icon-check width="8em" color="#3fae29"></tenable-icon-check>

        <h2>Success</h2>
        <h4>Please check your email for enrollment confirmation and password setup instructions.</h4>
      </div>
    `;
  }
}

customElements.define('tenable-partners-registration-confirmation', PartnersRegistrationConfirmation);
